import { createApiCall } from 'lib/base';

const CREATE_SELL_ORDER_API_ID = 'DASHBOARD/CREATE_SELL_ORDER_API_ID';

const apiCall = createApiCall(CREATE_SELL_ORDER_API_ID, payload => ({
  endpoint: `/api/admin/user-program-orders/create-sell`,
  method: 'POST',
  body: payload,
  notify: true,
}));

export default apiCall;
